module.exports = __webpack_public_path__ + "img/air_traffic_control.3715685d.svg";